module.exports = __webpack_public_path__ + "assets/fc5445cda9265c838f945924f1a09996.svg";